export const Region = {
  LeftTop: 'LeftTop',
  Top: 'Top',
  RightTop: 'RightTop',
  LeftBottom: 'LeftBottom',
  Bottom: 'Bottom',
  RightBottom: 'RightBottom',
};

const RegionMap = [
  [Region.LeftTop, Region.Top, Region.RightTop],
  [Region.LeftBottom, Region.Bottom, Region.RightBottom],
];

const getRelativePos = absPos => {
  const { scrollLeft, scrollTop } = document.documentElement;
  return {
    x: absPos.x - scrollLeft,
    y: absPos.y - scrollTop,
  };
};

/**
 * 获取坐标所在区域
 * @param {object} absPos
 * @param {number} absPos.x
 * @param {number} absPos.y
 * @returns {string} Region
 */
export const getPosRegion = absPos => {
  const { clientWidth, clientHeight } = document.body;
  const pos = getRelativePos(absPos);
  const rows = RegionMap.length;
  const cols = RegionMap[0].length;
  const uw = clientWidth / cols;
  const uh = clientHeight / rows;

  let rowIdx = 0;
  let colIdx = 0;

  for (let i = 0; i < cols; i++) {
    if (pos.x >= uw * i) {
      colIdx = i;
    }
  }

  for (let j = 0; j < rows; j++) {
    if (pos.y >= uh * j) {
      rowIdx = j;
    }
  }

  return RegionMap[rowIdx][colIdx];
};
